import { render, staticRenderFns } from "./ThirdAnniversary.vue?vue&type=template&id=573b938c&"
import script from "./ThirdAnniversary.vue?vue&type=script&lang=js&"
export * from "./ThirdAnniversary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports